export default "__VITE_ASSET__DImW1BHn__"